import { useState } from "react"
import { Tag, Text, Icon, Skeleton } from "components/common"
import theme from "utils/themeVars"
import { t } from "i18next"

const ProjectTags = ({ projects = [], loading = false }) => {
  const [showAll, setShowAll] = useState(false)
  const visibleCount = 3

  if (loading) {
    return <Skeleton active paragraph={{ rows: 1 }} />
  }

  if (!projects || projects.length === 0) {
    return (
      <Text type="secondary" className="fs14">
        {t("No projects discussed")}
      </Text>
    )
  }

  const visibleProjects = showAll ? projects : projects?.slice(0, visibleCount)
  const remainingCount = projects?.length - visibleCount

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
      {visibleProjects.map((project, index) => (
        <Tag
          key={index}
          pill
          style={{
            color: theme["accent-color"],
            "--tag-bg": theme["accent-color-light"],
            height: 25,
          }}
        >
          <Text color={theme["accent-color"]}>
            {project?.name} ({project?.count})
          </Text>
          {index === 0 && <Icon icon="AiFillStar" color="#f5c003" />}
        </Tag>
      ))}

      {!showAll && remainingCount > 0 && (
        <Tag
          pill
          style={{
            color: theme["accent-color"],
            "--tag-bg": theme["accent-color-light"],
            height: 25,
          }}
          className="pointer"
          onClick={() => setShowAll(true)}
        >
          <Text color={theme["accent-color"]}>+{remainingCount}</Text>
        </Tag>
      )}
    </div>
  )
}

export default ProjectTags
